export default "__VITE_ASSET__B2GhJOLI__"